/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

import axios from 'axios';
import { AuthProvider } from 'react-oidc-context';
import LoggProvider from './features/Common/LoggProvider';
import ScrollToTop from './features/Common/ScrollToTop';
import LocaleProvider from './Locale/LocaleProvider';
import userManager from './User/userManager';

import App from './App';
import './index.css';
import './index.scss';
import store from './state/store';

import { entrepenorkontrollUrl } from './api/urls';
import { GeonorgeProvider } from './context/Geonorge';
import DisplayStateProvider from './features/Common/DisplayStateProvider';
import StatiskeDataProvider from './features/Common/StatiskeDataProvider';
import * as serviceWorker from './serviceWorker';
import UserProvider, {
  registrerTokenPaaForesporsler,
} from './User/UserProvider';
import { sesjonsLogg, skrivOppstartslogg } from './User/sesjonsLogg';

axios.defaults.baseURL = entrepenorkontrollUrl;
registrerTokenPaaForesporsler();

skrivOppstartslogg();

const onSigninCallback = (user) => {
  const returnTo = user?.state?.returnTo;
  sesjonsLogg('signin-callback', {
    returnTo,
    urlHarCode: window.location.search.indexOf('code=') > -1,
  });
  if (returnTo) {
    window.location.replace(returnTo);
  } else {
    window.history.replaceState({}, document.title, window.location.pathname);
  }
};

ReactDOM.render(
  <AuthProvider userManager={userManager} onSigninCallback={onSigninCallback}>
    <GeonorgeProvider>
      <Provider store={store}>
        <LoggProvider>
          <BrowserRouter>
            <UserProvider>
              <ScrollToTop>
                <LocaleProvider>
                  <StatiskeDataProvider>
                    <DisplayStateProvider>
                      <App />
                    </DisplayStateProvider>
                  </StatiskeDataProvider>
                </LocaleProvider>
              </ScrollToTop>
            </UserProvider>
          </BrowserRouter>
        </LoggProvider>
      </Provider>
    </GeonorgeProvider>
  </AuthProvider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
